// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export class Module extends Vue {
  @Prop({ default: () => ({}) })
  public module!: object;

  @Prop({ default: "de" })
  public lang!: string;

  @Prop({ default: "GLOBAL" })
  public country!: string;

  @Prop({ default: "auto" })
  public forceBackground!: string;

  public isComponentsExisting() {
    let name = "Module" + this.module["type"];

    return name in this.$options.components!;
  }

  get componentProps() {
    let props = {
      instance: this.module["content"],
      forceBackground: this.module["forceBackground"]
        ? this.module["forceBackground"]
        : "auto",
    };

    if (!this.isComponentsExisting()) {
      props["type"] = this.module["type"];
    }

    return props;
  }

  get componentName() {
    if (this.isComponentsExisting()) {
      return "Module" + this.module["type"];
    } else {
      return "ModuleNotImplementedModule";
    }
  }
}
